import React from 'react';
import {connect} from 'react-redux';
import lifecycle from 'recompose/lifecycle';
import compose from 'recompose/compose';
import * as ResourceApi from "api/resources";
import {getAllResourcesAction} from "resources/actions";
import {filterOptionsFactory, sortOptionsFactory} from "viewOptions/factories";
import ColorPaletteDropdown from "components/forms/CustomFields/ColorPaletteDropdown";
import {createResourceTypeSelector} from "resources/selectors";
import {setBreakPaletteAction} from 'pages/EditBreak/actions';

const getPaletteItems = createResourceTypeSelector(ResourceApi.Types.Palette);

const mapStateToProps = (state) => {
  let breakId = state.editBreak.break[state.editBreak.currentPlatform];

  return ({
      options: getPaletteItems(state.resources),
      breakId: breakId
  });
};

//NOTE: Create actions file for color palette dropdown for custom set/get PaletteAction
const mapDispatchToProps = (dispatch) => ({ //NOTE: Sort alphabetically based on up or down. Make a getAllPalettesAction for readability.
    getPalettes: () => dispatch(getAllResourcesAction(ResourceApi.Types.Palette, sortOptionsFactory(), filterOptionsFactory())),
    setPalette: (breakId, paletteObject) => dispatch(setBreakPaletteAction(breakId,paletteObject)),
});

const ColorPaletteDropdownConnected = connect(mapStateToProps, mapDispatchToProps);

const ColorPaletteDropdownLifecycle = lifecycle({
    componentDidMount: function() {
        this.props.getPalettes();
    }
});

const ColorPaletteDropdownComposed = compose(
    ColorPaletteDropdownConnected,
    ColorPaletteDropdownLifecycle
)(ColorPaletteDropdown);

export default ColorPaletteDropdownComposed



// WEBPACK FOOTER //
// ./public/components/composites/ColorPaletteDropdownConnected.jsx